var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ag-instrument"},[_c('div',{staticClass:"instrument"},[_vm._v(_vm._s(_vm.params.data.symCd))]),_c('div',{staticClass:"margin"},[_vm._v(_vm._s(_vm.params.data.marginMode == undefined ? '' : _vm.params.data.marginMode == '1' ? "CROSS" : "ISOLATED")+" "+_vm._s(_vm.params.data.lv)+"x")])])
}
var staticRenderFns = []

export { render, staticRenderFns }